<template>
  <div>
    <card title="Incentifyer Accounts" :subtitle="''">
      <div>
        <Incentifyer-Accounts-Table/>
      </div>
    </card>
  </div>
</template>

<script>
export default {
  name: 'Incentifyer-Accounts-Card'
}
</script>

<style>

</style>